<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <template v-for="(obj,index) in classRoom">
            <v-row>
                <v-col>
                    <v-card
                        class="mx-auto"
                    >
                        <v-img
                            class="white--text align-end"
                            height="400px"
                            :src="getImg(index)"
                        >
                            <v-card-title>{{roomName(obj)}}</v-card-title>
                        </v-img>
                        <v-card-actions>
                            <v-btn
                                v-5="permissionCode.update"
                                color="orange"
                                text
                                @click="update(obj.roomId)"
                            >
                                修改
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>
<style></style>
<script>
    export default {
        data() {
            return {
                permissionCode:{
                    update:'biz:room:update',
                },
                classRoom:[],
            }
        },
        methods: {
            update(id) {
                this.$router.push({
                    name: "SeatTemplate",
                    params: {
                        id: id
                    }
                })
            },
            getImg(index){
                return require("@/assets/js"+index+".jpg")
            },

        },
        mounted(){
            this.$api.bizClassRoom.selectAllClassRoom().then((data)=>{
                this.classRoom = data.data;
            })
        },
        computed:{
            roomName(obj){
                return function(obj){
                    if(obj.className){
                        return obj.roomName+" [ET"+obj.className+"]"
                    }else{
                        return obj.roomName+" [空教室]"
                    }
                }
            }
        },
        components: {},
    }
</script>
